import { render } from "./ProgramsDetails.vue?vue&type=template&id=b14cb980&scoped=true"
import script from "./ProgramsDetails.vue?vue&type=script&lang=js"
export * from "./ProgramsDetails.vue?vue&type=script&lang=js"

import "./ProgramsDetails.vue?vue&type=style&index=0&id=b14cb980&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14cb980"]])

export default __exports__